import { csiAPI } from "src/boot/axios"
import { CSIurl } from "src/util/enums/urls"
import { concatUrl, getCustomConfig, getNewAbortHandler } from "src/util/http/httpHelper"
import { ObjectList } from "src/util/types/dataModels/genericObject"
import { EntityUrlName, History } from "src/util/types/dataModels/history"
import { HttpConfig } from "src/util/types/dataModels/http"
import {
  PERMISSION_ACCESS_READ,
  PERMISSION_ATTRIBUTES,
  PERMISSION_IDENTIFIERS,
  PERMISSION_ISSUES,
  PERMISSION_ITEMS,
  PERMISSION_USER_ACCOUNTS,
  UserPermissionType,
} from "src/util/types/dataModels/user"

export async function getEntityHistory(
  config: HttpConfig = {},
  entityName: EntityUrlName,
  entityId: string
): Promise<ObjectList<History>> {
  const entityURL = CSIurl.HISTORY_ENTITY.replace("{entity_url_name}", entityName).replace(
    "{entity_id}",
    entityId
  )
  const url = concatUrl(entityURL, { ...config?.mainParams })
  const abortHandler = config?.abortHandler || getNewAbortHandler("GET", entityURL)
  const permissionType = getPermissionTypeByEntityName(entityName)
  const customConfig = getCustomConfig(abortHandler, permissionType, PERMISSION_ACCESS_READ)
  const signal = abortHandler.controller.signal

  const { data } = await csiAPI.get(url, { signal, customConfig })

  return data
}

export async function getUserHistory(
  config: HttpConfig = {},
  userId: string
): Promise<ObjectList<History>> {
  const entityURL = CSIurl.HISTORY_USER.replace("{user_id}", userId)
  const url = concatUrl(entityURL, { ...config?.mainParams })
  const abortHandler = config?.abortHandler || getNewAbortHandler("GET", entityURL)
  const customConfig = getCustomConfig(
    abortHandler,
    PERMISSION_USER_ACCOUNTS,
    PERMISSION_ACCESS_READ
  )
  const signal = abortHandler.controller.signal

  const { data } = await csiAPI.get(url, { signal, customConfig })

  return data
}

function getPermissionTypeByEntityName(entityName: EntityUrlName): UserPermissionType | undefined {
  switch (entityName) {
    case "attributes/char":
    case "attributes/numeric":
    case "attributes/select":
    case "attributes/select/options":
    case "attributes/temporal":
      return PERMISSION_ATTRIBUTES

    case "identifiers":
      return PERMISSION_IDENTIFIERS

    case "issuepriorities":
    case "issues/onarea":
    case "issues/onarea/comments":
    case "issues/onarea/actions":
    case "issues/onarea/materials":
    case "issues/onitem":
    case "issues/onitem/comments":
    case "issues/onitem/actions":
    case "issues/onitem/materials":
      return PERMISSION_ISSUES

    case "itemclasses":
    case "itemmodels":
    case "items":
      return PERMISSION_ITEMS

    case "users":
      return PERMISSION_USER_ACCOUNTS
  }
}
